module.exports = __webpack_public_path__ + "media/images/pic/handshake-aac823925147cbf21302dba9223dad3f.jpg";